import React from "react";

const style = {
  fullScreen: {
    top: 0,
    left: 0,
    position: "fixed",
    width: "100vw",
    height: "100vh",
    backgroundColor: "#1b1b27",
    color: "#fff",
    zIndex: 99999,
  },
  // Size and position live in .cx-call-minimized (index.css) so it can
  // shrink on narrow screens
  minimized: {
    position: "fixed",
    backgroundColor: "#171722",
    color: "#fff",
    zIndex: 99999,
    transition: "all 150ms ease-in-out",
    borderTop: "1px solid rgba(255, 255, 255, 0.12)",
    borderRight: "1px solid rgba(255, 255, 255, 0.12)",
    borderTopRightRadius: "14px",
    boxShadow: "0 -8px 24px rgba(0, 0, 0, 0.35)",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
};

function ActiveCallContainer({ minimized, children }) {
  return (
    <div
      className={minimized ? "cx-call-minimized" : undefined}
      style={minimized ? style.minimized : style.fullScreen}
    >
      <div style={style.container}>{children}</div>
    </div>
  );
}

export default ActiveCallContainer;
